<div class="flex flex-col md:px-12 px-8 pr-8 border-b border-b-neutral-90" *ngIf="trailer">
  <div class="form-row">
    <div class="form-field">
      <div class="uppercase-label">{{ 'global.scac' | translate }} #</div>
      <div class="value">{{ trailer.scacCode }}</div>
    </div>
    <div class="form-field">
      <div class="uppercase-label">{{ 'yardControl.arriveForm.trailerNumber' | translate }}</div>
      <div class="value">{{ trailer.trailerNumber }}</div>
    </div>
  </div>

  <div class="form-row">
    <div class="form-field">
      <div class="uppercase-label">{{ 'yardControl.arriveForm.trailerType' | translate }}</div>
      <mat-chip disabled>{{ 'yardControl.lists.trailerType.' + trailer.trailerType | translate }}</mat-chip>
    </div>

    <div class="form-field">
      <div class="uppercase-label">{{ 'yardControl.arriveForm.trailerStatus' | translate }}</div>
      <mat-chip disabled>{{ 'yardControl.lists.trailerStatus.' + trailer.trailerStatus | translate }}</mat-chip>
    </div>
  </div>
</div>
